import clsx from "clsx";
import styles from "./styles.module.css";
import Lottie from "react-lottie";
import animationData from '../../assets/lottie/loader.json';
import { useTranslation } from "react-i18next";

interface LoaderProps {
  transparent?: boolean;
}

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

function Loader({ transparent = false }: LoaderProps) {
  const { t } = useTranslation();

  return (
    <div className={clsx(styles.loaderContainer, transparent && styles.transparentLoader)}>
      {/* <div className={clsx(styles.loader)}>&nbsp;</div> */}
      <Lottie
        className={clsx(styles.loaderLottie)}
        options={defaultOptions}
        isPaused={false}
        isStopped={false}
        eventListeners={[
          {
            eventName: 'complete',
          },
        ]}
        style={{
          width: '150px',
          height: 'auto',
          // backgroundColor: 'var(--gray-shade-1)',
        }}
      />
      <div style={{ color: transparent ? "white" : "black", fontWeight: 'bold' }}>
        {t("pleaseWait")}
      </div>
    </div>
  )
}
export default Loader;